// extracted by mini-css-extract-plugin
export default {"root":"styles_root__+3Ws+","advanced":"styles_advanced__hY0Fp","text":"styles_text__fsF6T"};